import { combineReducers } from "redux";

import Login from "./Login/login";
import SellerDashboard from "./SellerDashBoard/selleDashBoard";
import Timer from "./Timer/Timer";
import cartReducer from "./Cart/cart";
export default combineReducers({
  Login: Login,
  SellerDashboard: SellerDashboard,
  Timer,
  cart: cartReducer,
});
